export const RELATION_TYPE = {
  AND: 'AND',
  OR: 'OR'
};
export const RELATION_VALUE = {
  [RELATION_TYPE.AND]: 'and',
  [RELATION_TYPE.OR]: 'or'
};
export const create = (type, {
  children = []
} = {}) => {
  if (!RELATION_VALUE[type]) {
    console.warn(`[AdvSearch] 创建逻辑运算符失败，无效类型: ${type}`);
    return null;
  }

  const len = children ? children.length : 0;

  if (len === 0) {
    return null;
  } // 如果关系操作列表中只有一个元素，可以直接将这个元素作为条件返回，可减少嵌套层级


  if (len === 1) {
    return children[0];
  }

  return {
    type: 'relation',
    builder: RELATION_VALUE[type],
    children
  };
};